module.exports = __webpack_public_path__ + "images/filter-icon-7bc9837e.svg";